import {FC} from 'react';
import {IMasterProcessLocalContentProps} from './IMasterProcessLocalContentProps';
import {LocalContentProcessModel} from '../../../../models/LocalContentProcessModel';
import {EnhancedDetailsList} from '../../../common/EnhancedDetailsList';
import {useMasterProcessLocalContent} from './useMasterProcessLocalContent';
import {Spinner} from '@fluentui/react';

export const MasterProcessLocalContent: FC<IMasterProcessLocalContentProps> = ({
  isOpen,
  masterProcessIds,
}) => {

  const {processes, columns, isLoading} = useMasterProcessLocalContent(isOpen,masterProcessIds);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <EnhancedDetailsList<
          LocalContentProcessModel,
          LocalContentProcessModel,
          LocalContentProcessModel
        >
          key="master-process-local-content"
          columns={columns}
          items={processes}
          hideShowAll
          excelExport
          excelFileName="Exported Process List with Local Content"
        />
      )}
    </>
  );
};
